/* eslint-disable no-unused-vars */

import { Questions } from "./../../../../apps/web/src/types/questions";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { parseQueryString } from "../utilities/query-string";

export type Answer = {
  question: Questions;
  step: number;
  iteration: number;
  response: string | null;
};

type IframeParams = {
  codCanal: string;
  codMarca: string;
  codCampana: string;
  codConsultant: string;
  codCountry: string;
  vieneDe: string;
};

type Base = {
  codsap: string;
  nameProduct: string;
  typeProduct: string;
  tonality: string;
  codcuc: string;
  imageProduct: string;
};

export type SourceSystem = "vtex_mto" | "vtex_ecom" | "catalogo" | "none";

type Store = {
  currentAnswer: Answer | null;
  accumulativeAnswers: Answer[];
  phoneNumber: string;
  iframeParams: IframeParams;
  baseSelected: Base | null;
  setBaseSelected: (base: Base | null) => void;
  powderSelected: Base | null;
  setPowderSelected: (powder: Base | null) => void;
  hasAnswer: (
    question: Questions,
    step: number,
    iteration: number,
    includeCurrent?: boolean,
  ) => boolean;
  setCurrentAnswer: (
    question: Questions,
    step: number,
    iteration: number,
    response: string,
  ) => void;
  answerQuestion: (
    question: Questions,
    step: number,
    iteration: number,
    response: string,
  ) => void;
  reset: () => void;
  resetQuestionary: () => void;
  setPhoneNumber: (phoneNumber: string) => void;
  getSource: () => SourceSystem;
  setIframeParams: () => void;
  validateSource: () => boolean;
};

export const APP_SHELL_SESSION_KEY = "app-shell";

export const useAppShell = create<Store>()(
  persist<Store>(
    (set, get) => ({
      currentAnswer: null,
      accumulativeAnswers: [] as Answer[],
      phoneNumber: "",
      iframeParams: {} as IframeParams,
      baseSelected: null,
      setBaseSelected: (base: any) => set({ baseSelected: base }),
      powderSelected: null,
      setPowderSelected: (powder: any) => set({ powderSelected: powder }),
      hasAnswer: (question, step, iteration = 1, includeCurrent = true) => {
        const { accumulativeAnswers, currentAnswer } = get();
        return (
          accumulativeAnswers.findIndex(
            (it) =>
              it.question === question &&
              it.step === step &&
              it.iteration === iteration,
          ) !== -1 ||
          (includeCurrent &&
            currentAnswer?.question === question &&
            currentAnswer?.step === step &&
            currentAnswer?.iteration === iteration)
        );
      },
      setCurrentAnswer: (question, step, iteration = 1, response) =>
        set(() => ({ currentAnswer: { question, step, iteration, response } })),
      answerQuestion: (question, step, iteration = 1, response) => {
        if (get().hasAnswer(question, step, iteration, false)) {
          set((state) => ({
            accumulativeAnswers: state.accumulativeAnswers.map((answer) =>
              answer.question === question &&
              answer.step === step &&
              answer.iteration === iteration
                ? { ...answer, response }
                : answer,
            ),
          }));
        } else {
          set((state) => ({
            accumulativeAnswers: ([] as Answer[]).concat(
              state.accumulativeAnswers,
              [
                {
                  question,
                  step,
                  iteration,
                  response,
                },
              ],
            ),
          }));
        }
      },
      reset: () =>
        set(() => ({
          currentAnswer: null,
          accumulativeAnswers: [],
          baseSelected: null,
          powderSelected: null,
        })),
      resetQuestionary: () =>
        set(() => ({
          currentAnswer: null,
          accumulativeAnswers: [],
        })),
      setPhoneNumber: (phoneNumber: string) => set(() => ({ phoneNumber })),
      getSource: () => {
        const queryString =
          (typeof window !== "undefined" && window.location.search) || "";
        const { vieneDe } = parseQueryString(queryString);

        if (
          typeof window !== "undefined" &&
          (!window || window.self === window.top)
        ) {
          return "none";
        }

        let sanitizedSource = (vieneDe || "").toLowerCase();
        if (sanitizedSource.startsWith("vtex_mto_")) return "vtex_mto";
        if (sanitizedSource === "vtex_ecom") return "vtex_ecom";
        if (sanitizedSource.startsWith("catalogo_")) return "catalogo";

        return "none";
      },
      setIframeParams: () => {
        const queryString =
          (typeof window !== "undefined" && window.location.search) || "";
        const {
          cod_canal,
          cod_marca,
          cod_campana,
          cod_consultant,
          cod_country,
          vieneDe,
        } = parseQueryString(queryString);
        console.log("cod_canal", cod_canal);
        console.log("cod_marca", cod_marca);
        console.log("cod_campana", cod_campana);
        console.log("cod_consultant", cod_consultant);
        console.log("cod_country", cod_country);
        console.log("vieneDe", vieneDe);

        set(() => ({
          iframeParams: {
            codCanal: cod_canal || "",
            codMarca: cod_marca || "",
            codCampana: cod_campana || "",
            codConsultant: cod_consultant || "",
            codCountry: cod_country || "",
            vieneDe: vieneDe || "",
          },
        }));
      },
      validateSource: () => get().getSource() !== "none",
    }),
    {
      name: APP_SHELL_SESSION_KEY,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
